export default function Battery() {
  return (
    <svg
      width="39"
      height="66"
      viewBox="0 0 39 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Battery icon</title>
      <g>
        <path
          d="M21.866 2.33848H9.20398V0.574822C9.20398 0.261283 9.46398 0 9.77598 0H21.307C21.619 0 21.879 0.261283 21.879 0.574822V2.33848H21.866Z"
          fill="black"
        />
        <path
          d="M11.05 49.0167L15.093 31.5891L10.465 33.0392L13.286 17.1402H19.435L16.835 26.3243L23.426 24.2471L11.05 49.0167ZM26.338 3.48816H4.745C2.132 3.48816 0 5.63068 0 8.25657V57.2863C0 59.9122 2.132 62.0547 4.745 62.0547H7.839C5.447 59.5464 3.991 57.1817 3.926 57.0772L2.457 54.6996L5.109 53.8504C9.087 52.5701 12.662 51.9169 15.73 51.9169C19.071 51.9169 21.866 52.6616 24.063 54.1378C24.934 51.2114 27.066 48.0499 31.083 45.424V8.24351C31.083 5.61762 28.951 3.4751 26.338 3.4751"
          fill="black"
        />
        <path
          d="M33.8 49.709C35.594 48.3111 36.426 47.1484 36.426 47.1484C36.426 47.1484 36.257 48.1283 34.554 49.7613C29.159 54.9347 30.095 59.8468 31.499 62.8646C44.07 58.1223 37.024 41.0214 37.024 41.0214C37.024 41.0214 37.037 44.3527 33.007 46.7696C23.283 52.5962 24.596 61.7933 29.549 62.9299C28.392 59.6247 28.314 53.981 33.787 49.709"
          fill="black"
        />
        <path
          d="M24.661 60.7875C24.388 60.1604 24.193 59.481 24.076 58.7495C23.985 58.1485 23.946 57.5084 23.972 56.8421C21.281 54.3207 16.003 52.6224 5.75903 55.9145C5.75903 55.9145 15.821 72.2708 26.091 63.335C18.564 57.5867 11.713 57.5867 11.713 57.5867C11.713 57.5867 17.173 56.1105 24.635 60.7875"
          fill="black"
        />
      </g>
    </svg>
  );
}
